import React from 'react';
import { Redirect } from 'react-router-dom';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import TaxRules from '../../components/flightSelection/taxRules/TaxRules';
import FlightSelectionContainer from '../../components/flightSelectionContainer/FlightSelectionContainer';
import OverviewSearchBar from '../../components/overviewSearchBar/OverviewSearchBar';
import LoginContainer from '../../components/loginContainer/LoginContainer';
import Analytics from '../../components/modules/tudo-azul-analytics';
import Moment from 'moment';
import Listener from '../../const/Listener';
import FeatureService from '../../services/feature/FeatureService';
import { isFromCallcenter } from '../../services/queryService/QueryService';
import Features from '../../const/Features';
import EventEmitter from '../../components/modules/event-emitter/EventEmitter';
import RefreshTokenCallcenterProvider from '../../components/providers/refreshTokenCallcenter/RefreshTokenCallcenterProvider';
import './FlightPage.css';
import DynamicPanel from '../../components/bookingResume/dynamicPanel/DynamicPanel';
import RefundRulesDetail from '../../components/flightSelection/refundRulesDetail/RefundRulesDetail';

const I18n = require('i18n-react').default;
const CALCULATE_POINTS_LISTENER = 'calculate-points';

class FlightsPage extends React.Component {
  constructor() {
    super();

    this.state = {
      flightsResponse: null,
      flightsFilter: null,
      finalizeQuotation: false,
      showModal: false,
      isRedirect: false,
      renderTaxLink: false,
      isCallcenterEnabled: false,
      keepLoggedUser: false,
      pathname: '/',
      isRefundRulesDetailEnabled: false
    };

    this.calculatePoints = false;
    this.openTagRulesModal = this.openTagRulesModal.bind(this);
    this.closeTagRulesModal = this.closeTagRulesModal.bind(this);
    this.alterSearch = this.alterSearch.bind(this);
    this.updatePage = this.updatePage.bind(this);
    this.updateQuotationJourney = this.updateQuotationJourney.bind(this);
  }

  componentWillMount() {
    if (
      !this.props.location ||
      !this.props.location.state ||
      !this.props.location.state.result ||
      !this.props.location.state.filter
    ) {
      this.setState({
        isRedirect: true
      });
    } else {
      let quotationJourney = {
        passengers: {
          adultNumber: this.props.location.state.filter.totalAdults,
          childNumber: this.props.location.state.filter.totalKids,
          infantNumber: this.props.location.state.filter.totalBabys
        },
        origin: this.props.location.state.result.origin,
        finalDestination: this.props.location.state.result.finalDestination
      };
      this.setState({
        flightsResponse: this.props.location.state.result,
        flightsFilter: this.props.location.state.filter,
        quotationJourney: quotationJourney
      });
      this.fillCallCenterModeFeatureToggle();
      this.fillRefundRulesFeatureToggle();
    }
  }

  componentDidMount() {
    if (this.state.isRedirect === false) {
      window.scrollTo(0, 0);
      this.trackingSelect();

      this.setState({
        updateQuotationJourneylistener: EventEmitter.createListener(
          Listener.UPDATE_QUOTATION_JOURNEY,
          this.updateQuotationJourney
        )
      });
    }

    this.setState({
      successAvailabilitylistener: EventEmitter.createListener(
        Listener.LOADED_AVAILABILITY,
        this.loadedAvailability
      )
    });
  }

  fillCallCenterModeFeatureToggle() {
    FeatureService.isFeatureEnabled(Features.CALLCENTER_MODE).then(isEnabled => {
      if (isEnabled) {
        this.setState({
          isCallcenterEnabled: true
        });
      }
    });
  }

  componentWillUnmount() {
    EventEmitter.removeListener(this.state.updateQuotationJourneylistener);
    EventEmitter.removeListener(this.state.successAvailabilitylistener);
  }

  fillRefundRulesFeatureToggle() {
    FeatureService.isFeatureEnabled(Features.REFUND_RULES_DETAIL).then(isEnabled => {
      if (isEnabled) {
        this.setState({
          isRefundRulesDetailEnabled: true
        });
      }
    });
  }

  loadedAvailability = eventData => {
    const loaded = (eventData && eventData[0]) || false;
    this.setState({
      renderTaxLink: loaded
    });
  };

  updateQuotationJourney([quotationJourney]) {
    this.setState({
      quotationJourney: quotationJourney
    });
  }

  trackingSelect() {
    const filter = this.state.flightsFilter;
    const data = {
      departureDate: this.getFormatDate(filter.startDate),
      returnDate: this.getFormatDate(filter.endDate),
      tripType: filter.typeTrip,
      origin: filter.flightOrigin.code,
      destination: filter.flightDestiny.code,
      adults: filter.totalAdults,
      children: filter.totalKids,
      babies: filter.totalBabys,
      resultsQuantity: this.getResultsQuantity(this.state.flightsResponse)
    };
    this.setState({
      analyticsDataSelect: data
    });
    Analytics.trackingSelect(data);
  }

  getResultsQuantity(response) {
    let resultsQuantity = response.departureFlights.flights.length;
    if (response.returnFlights && response.returnFlights.flights) {
      resultsQuantity += response.returnFlights.flights.length;
    }
    return resultsQuantity;
  }

  getFormatDate(date) {
    let formatDate = null;
    if (date) {
      formatDate = Moment(date).format('YYYY-MM-DD');
    }
    return formatDate;
  }

  selectFlights = (departureFlight, returnFlight) => {
    this.calculatePoints = false;
    this.setState({
      finalizeQuotation: true,
      quotationJourney: {
        ...this.state.quotationJourney,
        departureFlight: departureFlight,
        returnFlight: returnFlight
      }
    });
  };

  alterFlights = () => {
    this.setState({
      finalizeQuotation: false
    });
  };

  openTagRulesModal() {
    this.setState({
      showModal: true
    });
  }

  closeTagRulesModal() {
    this.setState({
      showModal: false
    });
  }

  alterSearch() {
    this.setState({
      isRedirect: true,
      keepLoggedUser: this.callCenterMode()
    });
  }

  callCenterMode() {
    return this.state.isCallcenterEnabled && isFromCallcenter();
  }

  updatePage() {
    this.forceUpdate();
  }

  renderRefundRules() {
    if (this.state.isRefundRulesDetailEnabled && this.state.finalizeQuotation) {
      return (
        <DynamicPanel
          id="componentDynamicPanelRefundRules"
          title={I18n.translate('components.refundRulesDetail.title')}>
          <RefundRulesDetail
            departureFlight={this.state.quotationJourney.departureFlight}
            returnFlight={this.state.quotationJourney.returnFlight}
            passengers={this.state.quotationJourney.passengers}
          />
        </DynamicPanel>
      );
    }
  }

  renderFinalizeQuotation() {
    if (this.state.finalizeQuotation) {
      if (!this.calculatePoints) {
        this.calculatePoints = true;
        EventEmitter.emitEvent(CALCULATE_POINTS_LISTENER, this.state.quotationJourney);
      }

      return (
        <LoginContainer
          ref={ref => (this.loginContainer = ref)}
          quotationJourney={this.state.quotationJourney}
          flightsFilter={this.state.flightsFilter}
          callbackAlterSearch={this.alterSearch}
          analyticsDataSelect={this.state.analyticsDataSelect}
          location={this.props.location}
          isCallcenterEnabled={this.state.isCallcenterEnabled}
        />
      );
    }
  }

  renderRowFinalizeQuotation() {
    return (
      <div>
        <Row className="rules-finalize-login-row">
          <Col xs={12} className="no-padding text-left refund-rules-col">
            {this.renderRefundRules()}
          </Col>
          <Col xs={12} className="no-padding text-right">
            {this.renderFinalizeQuotation()}
          </Col>
          <Col xs={12} className="no-padding rate-rules-login-col">
            {this.renderTaxRulesLink()}
          </Col>
        </Row>
      </div>
    );
  }

  renderTaxRulesLink() {
    if (this.state.renderTaxLink) {
      return (
        <ControlLabel
          className="rate-rules"
          id="lblRateRules"
          onClick={this.openTagRulesModal}
          ref={c => (this.taxRules = c)}>
          {I18n.translate('flight.label.rateRules')}
        </ControlLabel>
      );
    }
  }

  render() {
    return (
      <div id="pageFlight">
        <RefreshTokenCallcenterProvider />
        <section className="container-fluid section__outer">
          {(() => {
            if (this.state.isRedirect) {
              return (
                <Redirect
                  push
                  to={{
                    pathname: this.state.pathname,
                    state: {
                      quotationJourney: this.state.quotationJourney,
                      flightsFilter: this.state.flightsFilter,
                      analyticsDataSelect: this.state.analyticsDataSelect,
                      keepLoggedUser: this.state.keepLoggedUser
                    },
                    search: this.props.location ? this.props.location.search : null
                  }}
                />
              );
            } else {
              return (
                <div>
                  <Row>
                    <Col xs={12}>
                      <OverviewSearchBar
                        origin={this.state.flightsFilter.flightOrigin.code}
                        destination={this.state.flightsFilter.flightDestiny.code}
                        departureDate={this.state.flightsFilter.startDate}
                        returnDate={this.state.flightsFilter.endDate}
                        totalAdults={this.state.flightsFilter.totalAdults}
                        totalKids={this.state.flightsFilter.totalKids}
                        totalBabys={this.state.flightsFilter.totalBabys}
                        alterSearchCallback={this.alterSearch}
                        alterFlightOverviewPrice={true}
                        steps={['components.steps.search', 'components.steps.flightSelection']}
                        history={this.props.history}
                        stepsBreadcrumb={[
                          'components.steps.search',
                          'components.steps.flightSelection'
                        ]}
                        actualStepBreadcrumb="components.steps.flightSelection"
                        ref={c => {
                          this.overviewSearchBar = c;
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <FlightSelectionContainer
                        id="flightSelectionContainer"
                        {...this.state.flightsResponse}
                        filter={this.state.flightsFilter}
                        callbackSelectFlights={this.selectFlights}
                        callbackAlterFlights={this.alterFlights}
                        updatePage={this.updatePage}
                        location={this.props.location}
                        renderTaxLink={!this.state.finalizeQuotation}
                        ref={c => {
                          this.flightSelectionContainer = c;
                        }}
                      />
                    </Col>
                  </Row>
                  {this.renderRowFinalizeQuotation()}
                  <TaxRules
                    id="flightsTax"
                    close={this.closeTagRulesModal}
                    showModal={this.state.showModal}
                    ref={c => (this.taxRulesModal = c)}
                  />
                </div>
              );
            }
          })()}
        </section>
      </div>
    );
  }
}

export default FlightsPage;



// WEBPACK FOOTER //
// ./src/page/flights/FlightsPage.jsx